"use client"
import { LayoutDashboard, MessageSquare, Users, X, Search } from "lucide-react"

export default function Sidebar({ activeTab, setActiveTab, userType, isOpen, setIsOpen }) {
  const menuItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: LayoutDashboard,
      available: ["agency"],
    },
    {
      id: "submit-feedback",
      label: "Submit Feedback",
      icon: MessageSquare,
      available: ["citizen"],
    },
    {
      id: "track-feedback",
      label: "Track Feedback",
      icon: Search,
      available: ["citizen", "agency"],
    },
    {
      id: "customer-engagement",
      label: "Customer Engagement",
      icon: MessageSquare,
      available: ["agency"],
    },
    {
      id: "engagement-management",
      label: "Engagement Management",
      icon: Users,
      available: ["agency"],
    },
    {
      id: "users",
      label: "User Management",
      icon: Users,
      available: ["agency"],
    },
  ]

  const filteredMenuItems = menuItems.filter((item) => item.available.includes(userType))
  const userName = localStorage.getItem("username") || "User"

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden" onClick={() => setIsOpen(false)} />
      )}

      {/* Sidebar */}
      <div
        className={`
        fixed lg:static inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out
        ${isOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
      `}
      >
        <div className="flex items-center justify-between h-16 px-6 border-b border-gray-200">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <MessageSquare className="w-5 h-5 text-white" />
            </div>
            <span className="ml-3 text-lg font-semibold text-gray-900">Feedback Portal</span>
          </div>
          <button onClick={() => setIsOpen(false)} className="lg:hidden p-1 rounded-md hover:bg-gray-100">
            <X className="w-5 h-5" />
          </button>
        </div>

        <nav className="mt-6 px-3">
          <div className="space-y-1">
            {filteredMenuItems.map((item) => {
              const Icon = item.icon
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    setActiveTab(item.id)
                    setIsOpen(false)
                  }}
                  className={`
                    w-full flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors
                    ${activeTab === item.id ? "bg-primary text-white" : "text-gray-700 hover:bg-gray-100"}
                  `}
                >
                  <Icon className="w-5 h-5 mr-3" />
                  {item.label}
                </button>
              )
            })}
          </div>
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
          <div className="flex items-center">
            <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-gray-700">{userName.split("")[0].toUpperCase()}</span>
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-900">{userName}</p>
              <p className="text-xs text-gray-500">{userType === "citizen" ? "Citizen" : "Agency"}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
